import { combineReducers } from 'redux';
import authReducer from 'services/ducks/auth';
import layoutReducer from 'services/ducks/layout'
import loadingReducer from 'services/ducks/loading';


export const Reducers = combineReducers({
    layoutState: layoutReducer,
    authState: authReducer,
    loadingState: loadingReducer
  });